export const SHOWROOM_GROUPS = ["all", "phones", "protection", "power", "audio", "wearables", "car", "studio"];

export const SHOWROOM = [
  {
    id: "phones",
    group: "phones",
    image: "/phones/samsung.png",
    fit: "contain",
    alt: "Samsung Galaxy S26 Ultra in silver, one of the new and used phones for sale",
  },
  {
    id: "cases",
    group: "protection",
    image: "https://images.unsplash.com/photo-1601593346740-925612772716?auto=format&fit=crop&w=1200&q=80",
    alt: "Hand holding a phone fitted with a textured protective case",
  },
  {
    id: "protectors",
    group: "protection",
    image: "https://images.unsplash.com/photo-1583863788434-e58a36330cf0?auto=format&fit=crop&w=1200&q=80",
    alt: "Technician applying a glass screen protector to a phone",
  },
  {
    id: "cables",
    group: "power",
    image: "https://images.unsplash.com/photo-1615526675159-e248c3021d3f?auto=format&fit=crop&w=1200&q=80",
    alt: "Wireless charger, braided cable and smartphone on a dark desk",
  },
  {
    id: "power",
    group: "power",
    image: "https://images.unsplash.com/photo-1600490722773-35753aea6332?auto=format&fit=crop&w=1200&q=80",
    alt: "Power bank charging a smartphone on a desk",
  },
  {
    id: "car",
    group: "car",
    image: "https://images.unsplash.com/photo-1709677848208-fa269b1088eb?auto=format&fit=crop&w=1200&q=80",
    alt: "Car dashboard with a phone holder mounted and ready",
  },
  {
    id: "audio",
    group: "audio",
    image: "/devices/airpods.png",
    fit: "contain",
    alt: "Apple AirPods earbuds in their charging case",
  },
  {
    id: "speakers",
    group: "audio",
    image: "/devices/speaker.png",
    fit: "contain",
    alt: "Portable wireless speaker",
  },
  {
    id: "smartwatches",
    group: "wearables",
    image: "/devices/watch-ultra.png",
    fit: "contain",
    alt: "Smartwatch with a black band and bright watch face",
  },
  {
    id: "memory",
    group: "studio",
    image: "https://images.unsplash.com/photo-1722554991596-1d262bf1880f?auto=format&fit=crop&w=1200&q=80",
    alt: "Close-up of a microSD memory card",
  },
  {
    id: "keyboards",
    group: "studio",
    image: "/devices/keyboard-rgb.png",
    fit: "contain",
    alt: "RGB backlit gaming keyboard",
  },
  {
    id: "creatorkit",
    group: "studio",
    image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=1200&q=80",
    alt: "Content creation desk with tripod, lights and dual monitors",
  },
  {
    id: "creator",
    group: "studio",
    image: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80",
    alt: "Camera lens and creator gear on a desk",
  },
  {
    id: "addons",
    group: "studio",
    image: "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?auto=format&fit=crop&w=1200&q=80",
    alt: "Smartphone and accessories arranged on a clean desk",
  },
  {
    id: "preowned",
    group: "phones",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1200&q=80",
    alt: "Person holding a smartphone in a shop",
  },
];
